import styled from "@emotion/styled";
import { FC, useMemo } from "react";
import { FieldMetaState } from "react-final-form";
import { useSelector } from "react-redux";

import { FormField, IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { TeamPickerListItem, TeamPickerSelectedListItem } from "components/picker-items/teamPickerItems";
import { selectTeamsAlphabetically } from "store/entities/teams";

interface IProps {
  filterValues: string[];
  placeholder: string;
  toggleOpen?: (isOpen: boolean) => void;
  labelText: string;
  onChange: (event: Array<string>) => void;
  isOpen?: boolean;
  meta: FieldMetaState<string>;
  id: string;
}

export type { IProps as ITeamsSelectProps };

export const TeamsSelect: FC<IProps> = ({
  filterValues,
  toggleOpen,
  placeholder,
  labelText,
  onChange,
  isOpen,
  meta,
  id,
}) => {
  const allTeams = useSelector(selectTeamsAlphabetically);

  const options = useMemo(
    () =>
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      allTeams.map<IPickerListItem>((team: any) => ({
        key: team.id,
        name: team.name,

        customElement: {
          listItemBody: <TeamPickerListItem name={team.name} pickerType="multi" isDefault={team.isDefault} />,
          selectedItemBody: <TeamPickerSelectedListItem name={team.name} pickerType="multi" />,
        },
      })),
    [allTeams]
  );

  const selectedOptions = useMemo(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => options.filter((option: any) => filterValues?.includes(option.key)),
    [filterValues, options]
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpen = () => {
    toggleOpen?.(true);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClose = () => {
    toggleOpen?.(false);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSelect = (selectedItems: IPickerListItem[] | null) => {
    if (!selectedItems) {
      return onChange([]);
    }

    return onChange(selectedItems.map(item => item.key));
  };

  return (
    <PickerWrapper labelText={labelText} error={meta.modified ? meta.error : undefined}>
      <Picker
        id={id}
        type="multi"
        isVisible={isOpen}
        options={options}
        placeholder={placeholder}
        selectAllOptionText="Select all"
        onSelect={handleSelect}
        selected={selectedOptions}
        maxListHeight={210}
        error={meta.modified ? meta.error : undefined}
        onOpen={handleOpen}
        onClose={handleClose}
      />
    </PickerWrapper>
  );
};

const PickerWrapper = styled(FormField)`
  width: 100%;
`;
